module.exports = __webpack_public_path__ + "img/linked_pods.5f3c771d.png";